"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSearch = TableSearch;
exports.TableSearchButton = TableSearchButton;
exports.TableSearchContent = TableSearchContent;

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _collapse = require("./collapse");

var _form = require("./forms/form");

var _iconButton = require("./buttons/icon-button");

var _submitButton = require("./buttons/submit-button");

var _styles = require("react-components/styles");

var _queryString = require("@slyk/query-string");

var _breakpoint = require("@slyk/breakpoint");

var _reactForms = require("@seegno/react-forms");

var _reactRouterDom = require("react-router-dom");

var _i18n = require("@slyk/i18n");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _excluded = ["className"];

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var closeIcon16 = "<svg fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M13.25 2.75l-10.5 10.5m10.5 0L2.75 2.75\" stroke=\"currentColor\" stroke-miterlimit=\"10\"/></svg>";
var searchIcon16 = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M9.21 10.332l5.933 4.6m-6.1-10.434c-1.307-1.906-6.22-1.906-7.527 0-.42.614-.633 1.667-.633 3.167 0 1.493.206 2.547.626 3.16 1.26 1.847 6.234 1.967 7.527.073.42-.613.633-1.693.633-3.24 0-1.493-.206-2.546-.626-3.16z\"/></svg>";
var searchIcon24 = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"1.2\" d=\"M13.8 14l8.9 6.9M13.55 5.25c-1.96-2.86-9.33-2.86-11.29 0-.63.92-.95 2.5-.95 4.75 0 2.24.31 3.82.94 4.74 1.89 2.77 9.35 2.95 11.29.11.63-.92.95-2.54.95-4.86 0-2.24-.31-3.82-.94-4.74z\"/></svg>";

/**
 * `Wrapper` styled component.
 */
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "table-search__Wrapper",
  componentId: "sc-5iwgxh-0"
})(["display:grid;grid-auto-columns:1fr auto;grid-template-areas:'.       searchButton' 'content content';"]);
/**
 * `Content` styled component.
 */


var Content = (0, _styledComponents["default"])(_collapse.Collapse).withConfig({
  displayName: "table-search__Content",
  componentId: "sc-5iwgxh-1"
})(["grid-area:content;"]);
/**
 * `StyledIconButton` styled component.
 */

var StyledIconButton = (0, _styledComponents["default"])(_iconButton.IconButton).withConfig({
  displayName: "table-search__StyledIconButton",
  componentId: "sc-5iwgxh-2"
})(["grid-area:searchButton;"]);
/**
 * `FormContainer` styled component.
 */

var FormContainer = _styledComponents["default"].div.withConfig({
  displayName: "table-search__FormContainer",
  componentId: "sc-5iwgxh-3"
})(["display:flex;flex-direction:column;margin-top:24px;", ""], _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-flow: row wrap;\n    gap: 0 8px;\n    margin-top: 0;\n\n    > * {\n      flex: 1 1 120px;\n    }\n  "]))));
/**
 * `StyledSubmitButton` styled component.
 */


var StyledSubmitButton = (0, _styledComponents["default"])(_submitButton.SubmitButton).withConfig({
  displayName: "table-search__StyledSubmitButton",
  componentId: "sc-5iwgxh-4"
})(["height:max-content;width:100%;", ""], _styles.media.min('md')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex: 0;\n    width: max-content;\n  "]))));
/**
 * Clean shallow.
 */

var cleanShallow = function cleanShallow(filters) {
  return Object.keys(filters).reduce(function (result, key) {
    if ((0, _isEmpty2["default"])(filters[key]) || (0, _isNil2["default"])(filters[key])) {
      return result;
    }

    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, filters[key]));
  }, {});
};
/**
 * Export `TableSearchButton` component.
 */


function TableSearchButton(props) {
  var isOpen = props.isOpen,
      toggle = props.toggle;

  var _useTranslate = (0, _i18n.useTranslate)(),
      translate = _useTranslate.translate;

  return /*#__PURE__*/_react["default"].createElement(StyledIconButton, {
    "aria-label": translate("common.actions.".concat(isOpen ? 'close' : 'search')),
    colorTheme: 'gray',
    icon: isOpen ? closeIcon16 : searchIcon16,
    onClick: toggle,
    size: 'small'
  });
}
/**
 * `TableSearchSubmitButton` component.
 */


function TableSearchSubmitButton(props) {
  var submitButtonLabel = props.submitButtonLabel;

  var _useTranslate2 = (0, _i18n.useTranslate)(),
      translate = _useTranslate2.translate;

  var isMobile = (0, _breakpoint.useBreakpoint)('md', 'max');

  var _useFormState = (0, _reactForms.useFormState)(),
      values = _useFormState.fields.values,
      meta = _useFormState.meta;

  var _ref = meta !== null && meta !== void 0 ? meta : {},
      isActive = _ref.active,
      isDirty = _ref.dirty;

  var hasValues = (0, _react.useMemo)(function () {
    return Object.values(values).some(function (value) {
      return !(0, _isNil2["default"])(value);
    });
  }, [values]);
  var isSearching = isActive && isDirty || hasValues;
  return /*#__PURE__*/_react["default"].createElement(StyledSubmitButton, {
    colorTheme: isSearching ? 'primary' : 'gray',
    icon: isMobile ? searchIcon16 : searchIcon24,
    iconColor: isSearching ? (0, _styles.color)('white') : (0, _styles.color)('gray500'),
    iconSize: isMobile ? '16px' : '24px',
    size: 'large'
  }, submitButtonLabel !== null && submitButtonLabel !== void 0 ? submitButtonLabel : translate('common.actions.search'));
}
/**
 * Export `TableSearchContent` component.
 */


function TableSearchContent(props) {
  var children = props.children,
      isOpen = props.isOpen,
      jsonSchema = props.jsonSchema,
      normalizeData = props.normalizeData,
      normalizeQuery = props.normalizeQuery,
      submitButtonLabel = props.submitButtonLabel;
  var history = (0, _reactRouterDom.useHistory)();
  var location = (0, _reactRouterDom.useLocation)();
  var query = (0, _queryString.useQueryString)();
  var normalizedInitialValues = (0, _react.useMemo)(function () {
    var _query$filter;

    var filterValues = (_query$filter = query === null || query === void 0 ? void 0 : query.filter) !== null && _query$filter !== void 0 ? _query$filter : {};
    var values = normalizeQuery ? normalizeQuery(filterValues) : filterValues;
    return (0, _pick2["default"])(values, Object.keys(jsonSchema.properties));
  }, [jsonSchema.properties, normalizeQuery, query]);
  var handleSubmit = (0, _react.useCallback)(function (data) {
    var filters = _objectSpread(_objectSpread({}, (0, _get2["default"])(query, 'filter', {})), normalizeData ? normalizeData(data) : data);

    history.push(_objectSpread(_objectSpread({}, location), {}, {
      search: (0, _queryString.formatQueryString)(_objectSpread(_objectSpread({}, query), {}, {
        filter: cleanShallow(filters)
      }))
    }));
    return Promise.resolve();
  }, [history, location, normalizeData, query]);
  return /*#__PURE__*/_react["default"].createElement(Content, {
    isOpen: isOpen
  }, /*#__PURE__*/_react["default"].createElement(_form.Form, {
    initialValues: normalizedInitialValues,
    jsonSchema: jsonSchema,
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement(FormContainer, null, children, /*#__PURE__*/_react["default"].createElement(TableSearchSubmitButton, {
    submitButtonLabel: submitButtonLabel
  }))));
}
/**
 * Export `TableSearch` component.
 */


function TableSearch(props) {
  var className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var isMobile = (0, _breakpoint.useBreakpoint)('md', 'max');
  var toggle = (0, _react.useCallback)(function () {
    setOpen(!isOpen);
  }, [isOpen]);
  (0, _react.useEffect)(function () {
    setOpen(!isMobile);
  }, [isMobile]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    className: className
  }, isMobile && /*#__PURE__*/_react["default"].createElement(TableSearchButton, {
    isOpen: isOpen,
    toggle: toggle
  }), /*#__PURE__*/_react["default"].createElement(TableSearchContent, _extends({
    isOpen: isOpen
  }, rest)));
}